import React from 'react'
import _ from 'lodash'
import PropTypes from 'prop-types'
import { TabBar } from 'camino-react'

import { cloudhelpGet } from 'Utilities/CloudHelp'
import TicketCorrespondenceForm from 'Components/Tickets/Correspondence/Form'
import TicketCorrespondenceLog from 'Components/Tickets/Correspondence/Log'
import History from 'Components/History'
import Attachments from 'Components/Attachments'
import TicketDetailsTicketInformation from 'Components/Tickets/Details/TicketInformation'

class TicketSupportDeskCorrespondence extends React.Component {
  constructor (props) {
    super(props)

    this.contentSections = ['Overview', 'Correspondence', 'Ticket history log']

    this.state = {
      currentCorrespondenceForm: null,
      currentContentSectionTab: this.contentSections[0]
    }
  }

  componentDidMount () {
    const { collectHistory } = this.props

    collectHistory()
  }

  toggleCorrespondenceForm = (event, correspondenceForm = null) => {
    event.preventDefault()

    const { currentCorrespondenceForm } = this.state

    if (currentCorrespondenceForm === correspondenceForm || _.isNil(correspondenceForm)) {
      this.setState({ currentCorrespondenceForm: null })
    } else {
      this.setState({ currentCorrespondenceForm: correspondenceForm })
    }
  }

  currentCorrespondenceFormTabClass = (type) => {
    const { currentCorrespondenceForm } = this.state

    if (currentCorrespondenceForm === type) {
      return 'tab-bar__item--active'
    }

    return ''
  }

  showContentSection = (event, correspondenceForm) => {
    event.preventDefault()
    this.setState({ currentContentSectionTab: correspondenceForm })
  }

  currentContentSectionTabClass = (type) => {
    const { currentContentSectionTab } = this.state

    if (currentContentSectionTab === type) {
      return 'content-section__header-tab--active'
    }

    return ''
  }

  render () {
    const { toggleCorrespondenceForm } = this
    const {
      ticket,
      attachmentAdmin,
      loading,
      currentUser,
      current_user,
      ticket_types: ticketTypes,
      ticket_statuses: ticketStatuses,
      problems,
      problemEndPoint,
      problemViewer,
      updateAlert,
      comments,
      addCommentToLog,
      updateTicket,
      history,
      historyLoading,
      collectHistory,
      roles,
      statusIds,
      allServiceCategories,
      watcherOptions,
      assignCurrentUser
    } = this.props
    const {
      currentCorrespondenceForm,
      currentContentSectionTab
    } = this.state

    const contentSectionHeaderTabs = _.map(this.contentSections, (sectionName, i) => (
      <button key={i} type="button" className={`content-section__header-tab ${this.currentContentSectionTabClass(sectionName)}`} onClick={event => (this.showContentSection(event, sectionName))}>
        {sectionName}
      </button>
    ))

    const correspondenceFormProps = type => (
      {
        ticket_id: ticket.id,
        hidden: currentCorrespondenceForm !== type,
        addCommentToLog,
        toggleCorrespondenceForm,
        collectHistory
      }
    )
    return (
      <section className="card content-section card--allow-overflow">
        <div key="header" className="content-section__header-tabs-container">
          {contentSectionHeaderTabs}
        </div>

        <div key="overview" id="ticket-overview" style={currentContentSectionTab === 'Overview' ? {} : { display: 'none' }}>
          <TicketDetailsTicketInformation
            currentUser={currentUser}
            ticket={ticket}
            ticket_types={ticketTypes}
            ticket_statuses={ticketStatuses}
            problems={problems}
            problemEndPoint={problemEndPoint}
            problemViewer={problemViewer}
            roles={roles}
            updateAlert={updateAlert}
            updateTicket={updateTicket}
            statusIds={statusIds}
            allServiceCategories={allServiceCategories}
            assignCurrentUser={assignCurrentUser}
          />
          <div key="attachments" className="content-section__content">
            <Attachments object={ticket} admin={attachmentAdmin} />
          </div>
        </div>

        <div key="correspondence" id="ticket-correspondence" className="content-section__content" style={currentContentSectionTab === 'Correspondence' ? {} : { display: 'none' }}>
          { _.isNull(ticket.primary_ticket_id) && (
            <>
              <TabBar spaced>
                <a className={`tab-bar__item ${this.currentCorrespondenceFormTabClass('Email')}`} onClick={(event) => { this.toggleCorrespondenceForm(event, 'Email') }}>
                Send email
                </a>
                <a className={`tab-bar__item ${this.currentCorrespondenceFormTabClass('Call Log')}`} onClick={(event) => { this.toggleCorrespondenceForm(event, 'Call Log') }}>
                Add call log
                </a>
                <a className={`tab-bar__item ${this.currentCorrespondenceFormTabClass('Internal Note')}`} onClick={(event) => { this.toggleCorrespondenceForm(event, 'Internal Note') }}>
                Add internal note
                </a>
              </TabBar>

              <TicketCorrespondenceForm
                currentUser={current_user}
                ticket={ticket}
                watchable
                watcherOptions={watcherOptions}
                communication_type="correspondence"
                {...correspondenceFormProps('Email')}
                ticketStatuses={ticketStatuses}
              />

              <TicketCorrespondenceForm
                currentUser={current_user}
                ticket={ticket}
                communication_type="call"
                {...correspondenceFormProps('Call Log')}
                ticketStatuses={ticketStatuses}
              />

              <TicketCorrespondenceForm
                currentUser={current_user}
                ticket={ticket}
                communication_type="internal_note"
                {...correspondenceFormProps('Internal Note')}
                ticketStatuses={ticketStatuses}
              />
            </>
          )}

          <TicketCorrespondenceLog comments={comments} loading={loading} />
        </div>

        <div key="history" className="content-section__content" id="ticket-history-log" style={currentContentSectionTab === 'Ticket history log' ? {} : { display: 'none' }}>
          {currentUser.calligo_employee && <History history={history} loading={historyLoading} />}
        </div>
      </section>
    )
  }
}

TicketSupportDeskCorrespondence.propTypes = {
  history: PropTypes.arrayOf(
    PropTypes.shape({}).isRequired
  ).isRequired,
  historyLoading: PropTypes.bool.isRequired,
  collectHistory: PropTypes.func.isRequired
}

export default TicketSupportDeskCorrespondence
